<template>
    <path fill-rule="evenodd" d="M16 0C7.163 0 0 7.163 0 16c0 8.836 7.163 16 16 16 8.836 0 16-7.163 16-16S24.836 0 16 0zm0 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm6.729-8.729l-5.268-5.269 5.238-5.195a.992.992 0 0 0 0-1.414 1.018 1.018 0 0 0-1.428 0l-5.231 5.188-5.309-5.31a1.007 1.007 0 0 0-1.428 0 1.015 1.015 0 0 0 0 1.432l5.301 5.302-5.331 5.287a.994.994 0 0 0 0 1.414c.394.39 1.034.391 1.429 0l5.324-5.28 5.276 5.276a1.007 1.007 0 0 0 1.428 0 1.015 1.015 0 0 0-.001-1.431z"/>
</template>

<script>
export default {
    name: 'closeCircleIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
